module.exports = __webpack_public_path__ + "img/contactus.9dd2d67c.jpg";